import axios from "axios";

export { vehicleTsSearchActions };

axios.defaults.withCredentials = true;

function vehicleTsSearchActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getAllImportTracking,
    getImportTrackingFilters,
    //getByCodeStatusReasons,
    exportDataImportTracking,
    // exportFileImportTrackingDataById,
    // exportErrorImportTrackingDataById,
    statusList,
    supplierList,
  };

  async function exportDataImportTracking(
    vin?: String | undefined,
    imei?: String | undefined,
    voucherNumber?: String | undefined,
    packageCode?: String | undefined,
    creationDateFrom?: any | null,
    creationDateTo?: any | null,
    processingStatus?: String[] | null,
    // supplier: String | null,
  ) {
    const exportAllDataImportTracking = await axios.post(
      `${baseUrl}/masterdatavehicle/telematics/excel`,
    {
      vin: vin,
      imei: imei,
      voucherNumber: voucherNumber,
      packageCode: packageCode,
      creationDateFrom: creationDateFrom,
      creationDateTo: creationDateTo,
      processingStatus: processingStatus,
    },
    {
      responseType: "arraybuffer", // o "arraybuffer" va bene, ma "blob" è più comodo per frontend
      headers: {
        "Access-Control-Allow-Origin": "*", // (true non è valido)
      },
    }
  );

    return exportAllDataImportTracking;
  }

  async function getAllImportTracking() {
    const getAllImportTracking = await axios.post(
      `${baseUrl}/masterdatavehicle/telematics/vehicle_ts_search`,
        {
        },
    );

    return getAllImportTracking;
  }

    async function getImportTrackingFilters(
            pageNumber: number | undefined,
            pageSize: number | undefined,
            vin?: String | undefined,
            imei?: String | undefined,
            voucherNumber?: String | undefined,
            packageCode?: String | undefined,
            creationDateFrom?: any | null,
            creationDateTo?: any | null,
            processingStatus?: String[] | null,
            // supplier: String | null,
    ) {
    const getAllImportTracking = await axios.post(
      `${baseUrl}/masterdatavehicle/telematics/vehicle_ts_search`,
        {
            pageNumber,
            pageSize,
            vin,
            imei,
            voucherNumber,
            processingStatus,
            creationDateFrom,
            creationDateTo,
            packageCode,
            //supplier,
        },
    );

    return getAllImportTracking;
  }

  async function statusList() {
    return [
      "PROCESSED", 
      "PROCESSING", 
      "FAILED"
    ];
  }

  async function supplierList() {
    return [
      "OCTO"
    ];
  }

  /*
  async function exportFileImportTrackingDataById(
    tenant: String | undefined,
    id?: String
  ) {
    const exportFileById = await axios.post(
      `${baseUrl}/masterdatavehicle/telematics/vehicle_ts_search/${id}/file`,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportFileById;
  }

  async function exportErrorImportTrackingDataById(
    tenant: String | undefined,
    id: String
  ) {
    const exportErrorById = await axios.post(
      `${baseUrl}/masterdatavehicle/telematics/vehicle_ts_search/${id}/errorfile`,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportErrorById;
  }
  */
}
